import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDeleteContactUsMutation,
  useGetMessageByIdQuery,
  useMarkAsReadMutation,
} from "../../redux/contactApi";
import { toast } from "react-toastify";
import ButtonLoading from "../Button loading/ButtonLoading";

const ContactUsMessage = () => {
  const { id } = useParams();

  const { data, isLoading: isMessageLoading } = useGetMessageByIdQuery(id);
  const firstLetter = data?.message?.email?.[0]?.toUpperCase() || "";
  const getRandomDarkColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 50%, 25%)`;
  };
  const randomBgColor = getRandomDarkColor();
  const navigate = useNavigate();

  const [deleteContactUs, { isLoading: isDeleteLoading }] =
    useDeleteContactUsMutation();
  const [markAsRead, { isLoading: isUpdateLoading }] = useMarkAsReadMutation();

  const handleDelete = async (id) => {
    try {
      const response = await deleteContactUs(id).unwrap();
      if (response.success) {
        navigate("/contact-us");
        toast.success(response?.message);
      }
    } catch (err) {
      console.error("contact us error:", err);
      toast.error(err.data.messaage);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      const response = await markAsRead(id).unwrap();
      if (response.success) {
        navigate("/contact-us");
        toast.success(response?.message);
      }
    } catch (err) {
      console.error("contact us error:", err);
      toast.error(err.data.messaage);
    }
  };

  return (
    <div className=" flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl xl:p-8 lg:p-6 p-4">
      <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
        Contact Message
      </p>
      {isMessageLoading ? (
        <div className=" flex flex-col md:gap-4 gap-2">
          <div className="flex justify-start items-center gap-5">
            <div className="h-10 w-10 rounded-lg bg-[#efefef] animate-pulse"></div>
            <div>
              <div className="h-3 w-40 rounded-full bg-[#efefef] animate-pulse"></div>
              <div className="h-3 w-40 rounded-full bg-[#efefef] animate-pulse"></div>
            </div>
          </div>
          <div className="h-6 w-full rounded-full bg-[#efefef] animate-pulse"></div>
          <div className=" flex flex-col gap-1">
            <div className="h-3 w-full rounded-full bg-[#efefef] animate-pulse"></div>
            <div className="h-3 w-full rounded-full bg-[#efefef] animate-pulse"></div>
            <div className="h-3 w-full rounded-full bg-[#efefef] animate-pulse"></div>
            <div className="h-3 w-full rounded-full bg-[#efefef] animate-pulse"></div>
            <div className="h-3 w-[50%] rounded-full bg-[#efefef] animate-pulse"></div>
          </div>
          <div className=" flex flex-col gap-1">
            <div className="h-3 w-40 rounded-full bg-[#efefef] animate-pulse"></div>
            <div className="h-3 w-[70%] rounded-full bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex items-center justify-end gap-4">
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col md:gap-4 gap-2">
          <div className=" flex justify-start items-center lg:gap-5 md:gap-4 gap-3">
            <div
              style={{ backgroundColor: randomBgColor }}
              className="  text-white md:text-[1.4rem] text-[1.1rem] font-semibold uppercase md:h-10 h-8 md:w-10 w-8 flex justify-center items-center rounded-lg"
            >
              {firstLetter}
            </div>
            <div>
              <p className=" text-black font-semibold md:text-[1.2rem] text-[1rem] capitalize">
                {data?.message?.name}
              </p>
              <p className=" text-[#8F8F8F] md:text-sm text-[12px]">
                {data?.message?.email}
              </p>
            </div>
          </div>
          <h1 className=" font-bold lg:text-[2rem] md:text-[1.6rem] text-[1.3rem] capitalize">
            {data?.message?.subject}
          </h1>
          <p className="text-[#8F8F8F] md:text-[1rem] text-sm">
            {data?.message?.message}
          </p>
          <div className=" md:text-[1rem] text-sm">
            {data?.message?.phone && (
              <p className="text-[#8F8F8F]">{data?.message?.phone}</p>
            )}
            <p className="text-[#8F8F8F]">{data?.message?.address}</p>
          </div>
          <div className=" flex items-center justify-end lg:gap-4 md:gap-3 gap-2 ">
            <button
              onClick={() => handleDelete(id)}
              className={`lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border text-center border-[#D80000] flex items-center justify-center 
              text-white bg-[#D80000] lg:rounded-xl md:rounded-lg rounded-md font-medium ${
                isDeleteLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "opacity-100 cursor-pointer"
              }`}
            >
              {isDeleteLoading ? (
                <ButtonLoading text="Deleting..." />
              ) : (
                "Delete"
              )}
            </button>
            {data?.message?.markAsRead === false && (
              <button
                disabled={isUpdateLoading}
                onClick={() => handleMarkAsRead(id)}
                className="lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border border-[#00643B] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-white bg-[#00643B] lg:rounded-xl md:rounded-lg rounded-md font-medium"
              >
                {isUpdateLoading ? (
                  <ButtonLoading text="Marked..." />
                ) : (
                  "Mark as Read"
                )}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUsMessage;
